import React from 'react'
import { ConfirmationOptions } from './ConfirmationDialog'

export default React.createContext<
  (options: ConfirmationOptions) => Promise<void>
>((...args) => Promise.reject(...args))
